module.exports = __webpack_public_path__ + "media/proksee-viewer/images/icon-snapshot-restore-c0ddca07045a81370517ab3a046c8e53.svg";